module.exports = __webpack_public_path__ + "images/remove_item-d3918f642b4b71aba789eb8042e54ff8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/remove_item.svg
// module id = 233
// module chunks = 0